<template>
  <header class="header">
    <div class="row expanded header__row">
      <div class="small-10 large-offset-1 medium-3 columns">
        <router-link title="Link do strony głównej" class="header__logo" :to="{ path: '/' }"><img src="/static/gainvest-logo.svg" alt="Logo Gainvest"></router-link>
      </div>
      <nav class="small-2 medium-9 large-7 columns">
        <ul class="menu">
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do podstrony dlaczego?" :to="{ path: '/dlaczego' }">Dlaczego?</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do zysku" :to="{ path: '/zysk' }">Dla kogo zysk?</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do podstrony rozwiazanie" :to="{ path: '/znajdz-rozwiazanie' }">Znajdź rozwiązanie</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item menu__item--red">
            <router-link title="Link do oferty" :to="{ path: '/oferta' }">Oferta</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do podstrony zespół" :to="{ path: '/zespol' }">Zespół</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do referencji" :to="{ path: '/referencje' }">Referencje</router-link>
          </li>
          <li v-on:click="menuClick" class="menu__item">
            <router-link title="Link do kontaktu" :to="{ path: '/kontakt' }">Kontakt</router-link>
          </li>
        </ul>
         <a href="#_" class="header__hamburger hamburger" v-on:click="menuClick" title="Rozwiń menu">
          <div class="hamburger__stripe"></div>
          <div class="hamburger__stripe"></div>
          <div class="hamburger__stripe"></div>
        </a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    menuClick: function (e) {
      const hamburger = document.querySelector('.header__hamburger')
      const menuContainer = document.querySelector('.menu')

      hamburger.classList.toggle('header__hamburger--visible')
      menuContainer.classList.toggle('menu--visible')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue